'use client'

export { QueryClientProvider } from '@tanstack/react-query'
export { default as ReactQueryDevtools } from 'shared/components/ReactQueryDevtools'
